import { Fragment, useState } from 'react';
import { PROJECT_NAME } from 'interface/common';
import { TenantConfiguration } from 'components/Tenant/TenantConfiguration';
import { Button, Divider, Drawer, Space, Typography } from 'antd';
import { ApiOutlined, BgColorsOutlined, BookOutlined, MoonOutlined, QuestionCircleOutlined, SettingOutlined, SunOutlined } from '@ant-design/icons';
import { TipBottom } from 'components/SharedComponents/Tooltip/Tooltip';
import { buttonColor } from 'utils/styles';

const { Title, Text } = Typography;

const DrawersData = (props: { body: any; title: string; icon: any; hoverIcon: any }) => {
  const [drawerState, setDrawerState] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const hoverOn = () => setIsHovered(true);
  const hoverOff = () => setIsHovered(false);

  return (
    <>
      <Space role="button" onClick={() => setDrawerState(true)} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>
        <TipBottom tip={props.title}>
          <Button type="text" icon={isHovered ? props.hoverIcon : props.icon} />
        </TipBottom>
      </Space>
      <Drawer width={300} title={props.title} onClose={() => setDrawerState(false)} open={drawerState}>
        {props.body}
      </Drawer>
    </>
  );
};

export const NhHelpDrawer = props => {
  const drawerHelp = (
    <Space direction="vertical">
      <Fragment key={`Need help?`}>
        <Title level={4}> Need help? </Title>
        <Space key="S1" direction="horizontal">
          <a href="mailto:support@unifie.cloud" target="_blank">
            <Button type="primary" icon={<QuestionCircleOutlined />} />
          </a>
          <Text> Look out for this icon to access help and related resources. </Text>
        </Space>
        <Divider />
      </Fragment>
      <Fragment key={`guide`}>
        <Title level={4}> How to guide </Title>
        <Space key="S2" direction="vertical">
          <Text> Learn how to utilize {PROJECT_NAME} full potential using guided tutorials, and in-depth help guides. </Text>
          <a href="https://www.unifie.cloud/doc/docs/Overview/" target="_blank">
            <Button type="primary" block>
              Start learning
            </Button>
          </a>
        </Space>
      </Fragment>
      <Divider />
      <Fragment key={`Help & Support`}>
        <Title level={4}> Help & Support </Title>
        <Space key="S3" direction="vertical">
          <Text>
            Reach out to our{' '}
            <a href="https://www.unifie.cloud/privacy-policy" target="_blank">
              support team
            </a>{' '}
            for further questions and assistance
          </Text>
          <a href="mailto:support@unifie.cloud" target="_blank">
            <Button type="primary" block>
              Contact us
            </Button>
          </a>
        </Space>
      </Fragment>
      <Divider />
      <Fragment key={`Help & Support`}>
        <Title level={4}> Chat & Community </Title>
        <Space key="Community" direction="vertical">
          <Text>Be part of our community, discuss and chat with other users and development team</Text>
          <a href="https://discord.gg/UeEr36eteV" target="_blank">
            <Button type="primary" block>
              Discord community
            </Button>
          </a>
        </Space>
      </Fragment>
      <Divider />
      <Fragment key={`Contact`}>
        <Title level={4}> Contact </Title>
        <Space key="Contact" direction="vertical">
          <a href="mailto:support@unifie.cloud" target="_blank">
            support@unifie.cloud
          </a>
        </Space>
      </Fragment>
    </Space>
  );

  return (
    <Space direction="horizontal">
      <a key={`docs`} href={`https://www.unifie.cloud/doc/docs/api-v1/`} target="_blank">
        <TipBottom tip="API documentation" key="api">
          <Button type="text" icon={<BookOutlined />} />
        </TipBottom>
      </a>

      <a key={`api`} href={`https://${window.location.host}/unifie-api/graphql/v1`} target="_blank">
        <TipBottom tip="API sandbox" key="api">
          <Button type="text" icon={<ApiOutlined />} />
        </TipBottom>
      </a>
      <Space key={`help`}>
        <DrawersData body={drawerHelp} title={'Help'} icon={<QuestionCircleOutlined />} hoverIcon={<QuestionCircleOutlined style={buttonColor} />} />
      </Space>
      <Space key={`themes`}>
        <DrawersData body={<TenantConfiguration />} title={'Theme'} icon={<SunOutlined />} hoverIcon={<MoonOutlined style={buttonColor} />} />
      </Space>
    </Space>
  );
};
